import React from "react";
import { Box, Button } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import "./action-buttons.component.scoped.scss";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
  focusedQuestionId: string | null;
  onSubmit: () => void;
  onPreview: () => void;
  saving: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  focusedQuestionId,
  onSubmit,
  onPreview,
  saving,
}) => {
  const { t } = useTranslation();

  return (
    <Box className="action-buttons">
      <Button
        variant="contained"
        onClick={onPreview}
        disabled={focusedQuestionId !== null || saving}
        className="preview-button"
      >
        {t("CHATBOT.PREVIEW")}
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        className="submit-button"
        disabled={focusedQuestionId !== null || saving}
        startIcon={<CheckCircle />}
      >
        {t("CHATBOT.CREATE_PRODUCT")}
      </Button>
    </Box>
  );
};

export default ActionButtons;
